var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography,
    borders = _ref.borders;
  return {
    marginAddMargin: spacing.xSmall,
    quizEntryBankEditBackgroundColor: colors.white,
    quizEntryBankEditBorderSize: borders.widthSmall,
    quizEntryBankEditBorderColor: colors.oxford,
    quizEntryBankEditPadding: borders.small,
    quizEntryBankEditMargin: spacing.medium,
    numberInputFontSize: typography.fontSizeMedium,
    numberInputPadding: spacing.xxSmall,
    numberInputLeftPadding: spacing.small,
    borderLineTopMargin: spacing.small,
    borderLineBottomMargin: spacing.small,
    borderLineBottomBorderSize: borders.widthSmall,
    borderLineBottomBorderColor: colors.ash
  };
};
export default generateComponentTheme;